import { useHistory } from "react-router-dom";
import { client } from "../../hooks/Client"
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import { useFirestoreOrderBy } from '../../firebase/useFirestore';
import { db } from '../../firebase/config';
import { useEffect, useState } from 'react';
import FundName from '../../components/financiers/FundName';
import DragIndicatorOutlinedIcon from '@mui/icons-material/DragIndicatorOutlined';
import Table from '../../components/common/table/Table.jsx';
import TableCell from '../../components/common/table/TableCell.jsx';
import TableDragHandleCell from '../../components/common/table/TableDragHandleCell.jsx';
import TableTitleCell from '../../components/common/table/TableTitleCell.jsx';

const Funds = () => {
    // State
    const [dragArray, setDragArray] = useState([]);

    // Hooks
    const history = useHistory()

    // Firestore
    const funds = useFirestoreOrderBy('CompanyFunds', 'Position', 'asc')

    useEffect(() => {
        setDragArray((prev) => {
            const next = funds || [];
            if (Array.isArray(prev) && prev.length === next.length) {
                const same = prev.every((p, i) => {
                    const n = next[i];
                    return p.docid === n.docid && p.Position === n.Position && p.Status === n.Status && p.FundID === n.FundID;
                });
                if (same) return prev;
            }
            return next;
        });
    }, [funds]);

    const handleDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(dragArray);
        const [moved] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, moved);

        setDragArray(items);

        items.forEach((item, idx) => {
            db.collection('CompanyFunds').doc(item.docid).update({ Position: idx + 1 });
        });
    };

    const deleteFund = (e) => {
        const docid = e.currentTarget.dataset.docid
        db.collection('CompanyFunds').doc(docid).delete()
    }

    return (
        <div className="main">
            <div className="main-container">
                <div className="page-header">
                    <h1>Mijn fondsen</h1>
                </div>
                <Table
                    columns={[
                        { key: 'drag', label: '', searchable: false },
                        { key: 'name', label: 'NAAM' },
                        { key: 'status', label: 'STATUS', searchable: false },
                        { key: 'delete', label: 'VERWIJDEREN', searchable: false },
                    ]}
                    items={dragArray || []}
                    draggable
                    droppableId="funds"
                    onDragEnd={handleDragEnd}
                    getItemKey={(item) => item.FundID || item.ID || item.docid}
                    emptyMessage="Nog geen fondsen gevonden."
                    searchAccessor={(item) => item?.Name || ''}
                    searchPlaceholder="Zoeken op naam"
                    addRow={{
                        toolTipContent: 'Fonds toevoegen',
                        onClick: () => history.push(`/${client}/allfunds`),
                    }}
                    renderRow={(item) => (
                        <>
                            <TableDragHandleCell>
                                <DragIndicatorOutlinedIcon />
                            </TableDragHandleCell>
                            <TableTitleCell
                                to={`/${client}/funddetails/${item.FundID}`}
                                readOnly
                                displayContent={<FundName id={item.FundID} />}
                            />
                            <TableCell>
                                {item.Status}
                            </TableCell>
                            <TableCell>
                                <DeleteOutlinedIcon className='table-delete-icon' data-docid={item.docid} onClick={deleteFund} />
                            </TableCell>
                        </>
                    )}
                />
            </div>
        </div>
    )
}

export default Funds
